export default "__VITE_ASSET__BAOZJYPV__"